/**
 * EXIT POPUP — Carrusel de productos al intentar salir
 * Atina Theme · v1.0
 *
 * - Se activa con exit intent (mouse sale del viewport) o timeout
 * - Muestra productos de una colección configurable
 * - Se muestra una vez cada 24 horas (localStorage)
 * - Carrusel horizontal con flechas
 */
(function () {
    'use strict';

    var CFG = window.__exitPopupConfig || {};
    if (!CFG.enabled) return;

    var STORAGE_KEY = 'ep_last_shown';
    var HOURS_BETWEEN = CFG.frequencyHours || 24;
    var DELAY_SECONDS = CFG.delaySeconds || 3;
    var COLLECTION_URL = CFG.collectionUrl || '';
    var TITLE = CFG.title || '¡No te vayas sin ver esto!';
    var SUBTITLE = CFG.subtitle || 'Productos que podrían encantarte';
    var EYEBROW = CFG.eyebrow || 'ANTES DE IRTE';
    var CTA_TEXT = CFG.ctaText || 'VER COLECCIÓN';
    var CTA_URL = CFG.ctaUrl || '/collections/all';
    var CURRENCY_FORMAT = CFG.currencyFormat || '${{amount}}';
    var MOBILE_TRIGGER = CFG.mobileTrigger || 'scroll';
    var TRIGGER_EXIT = CFG.triggerExit === true;
    var TRIGGER_TIMER = CFG.triggerTimer || false;
    var TIMER_SECONDS = CFG.timerSeconds || 15;

    // Verificar si ya se mostró recientemente (solo para exit intent, no para checkout)
    var lastShown = localStorage.getItem(STORAGE_KEY);
    var recentlyShown = false;
    if (lastShown) {
        var elapsed = Date.now() - parseInt(lastShown);
        if (elapsed < HOURS_BETWEEN * 60 * 60 * 1000) recentlyShown = true;
    }

    // Si se mostró recientemente Y no hay checkout trigger, salir
    if (recentlyShown && !CFG.checkoutTrigger) return;

    var hasTriggered = recentlyShown; // Si se mostró recientemente, no disparar exit intent
    var products = [];

    function formatMoney(cents) {
        var amount = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        return CURRENCY_FORMAT.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
    }

    // Cargar productos de la colección
    function loadProducts() {
        if (!COLLECTION_URL) return Promise.resolve([]);
        var url = COLLECTION_URL.replace(/\/$/, '') + '/products.json?limit=12';
        return fetch(url, { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (data) { return data.products || []; })
            .catch(function () { return []; });
    }

    // Renderizar popup
    function showPopup() {
        if (hasTriggered || !products.length) return;
        hasTriggered = true;
        localStorage.setItem(STORAGE_KEY, String(Date.now()));

        var html = '<div class="ep-overlay is-visible" id="ep-overlay">';
        html += '<div class="ep-modal">';

        // Close button
        html += '<button class="ep-modal__close" id="ep-close"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;display:block;"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';

        // Header
        html += '<div class="ep-modal__header">';
        html += '<div class="ep-modal__eyebrow">' + EYEBROW + '</div>';
        html += '<h2 class="ep-modal__title">' + TITLE + '</h2>';
        html += '<p class="ep-modal__sub">' + SUBTITLE + '</p>';
        html += '</div>';

        // Carousel
        html += '<div class="ep-carousel">';
        html += '<button class="ep-carousel__btn ep-carousel__btn--prev" id="ep-prev"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg></button>';
        html += '<button class="ep-carousel__btn ep-carousel__btn--next" id="ep-next"><svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg></button>';
        html += '<div class="ep-carousel__track" id="ep-track">';

        products.forEach(function (p, pIdx) {
            var image = (p.images && p.images[0]) ? p.images[0].src : '';
            var price = p.variants[0].price;
            var comparePrice = p.variants[0].compare_at_price;
            var hasDiscount = comparePrice && parseFloat(comparePrice) > parseFloat(price);
            var hasMultipleVariants = p.variants.length > 1;
            var anyAvailable = p.variants.some(function (v) { return v.available; });

            html += '<div class="ep-product" data-product-idx="' + pIdx + '">';
            if (hasDiscount) {
                var discountPct = Math.round((1 - parseFloat(price) / parseFloat(comparePrice)) * 100);
                html += '<span class="ep-product__badge">-' + discountPct + '%</span>';
            }
            html += '<div class="ep-product__img">';
            if (image) html += '<img src="' + image.replace(/\.([^.]+)$/, '_360x.$1') + '" alt="' + p.title + '" loading="lazy">';
            html += '</div>';
            html += '<div class="ep-product__info">';
            html += '<div class="ep-product__name">' + p.title + '</div>';
            html += '<div class="ep-product__price">' + formatMoney(parseFloat(price) * 100);
            if (hasDiscount) html += '<span class="ep-product__price-compare">' + formatMoney(parseFloat(comparePrice) * 100) + '</span>';
            html += '</div>';

            if (!anyAvailable) {
                html += '<span class="ep-product__add ep-product__add--sold">Agotado</span>';
            } else if (hasMultipleVariants) {
                // Variant selector inline
                html += '<div class="ep-product__variants" data-product-idx="' + pIdx + '">';
                var options = p.options || [];
                for (var oi = 0; oi < options.length; oi++) {
                    var optName = (typeof options[oi] === 'object') ? options[oi].name : options[oi];
                    var uniqueVals = [];
                    for (var vi2 = 0; vi2 < p.variants.length; vi2++) {
                        var v2 = p.variants[vi2];
                        var optVal = v2.options ? v2.options[oi] : (v2['option' + (oi + 1)] || '');
                        if (optVal && uniqueVals.indexOf(optVal) === -1) uniqueVals.push(optVal);
                    }
                    if (uniqueVals.length <= 1 && uniqueVals[0] === 'Default Title') continue;
                    html += '<select class="ep-product__select" data-option-idx="' + oi + '">';
                    html += '<option value="">' + optName + '</option>';
                    for (var uvi = 0; uvi < uniqueVals.length; uvi++) {
                        html += '<option value="' + uniqueVals[uvi] + '">' + uniqueVals[uvi] + '</option>';
                    }
                    html += '</select>';
                }
                html += '</div>';
                html += '<button class="ep-product__add" data-product-idx="' + pIdx + '" disabled>Selecciona</button>';
            } else {
                // Single variant - direct add
                html += '<button class="ep-product__add" data-variant-id="' + p.variants[0].id + '">Agregar <svg viewBox="0 0 24 24" width="12" height="12"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg></button>';
            }

            html += '</div></div>';
        });

        html += '</div></div>';

        // Footer
        html += '<div class="ep-modal__footer">';
        // html += '<a href="' + CTA_URL + '" class="ep-modal__cta">' + CTA_TEXT + '</a>';
        html += '<a href="/checkout" class="ep-modal__cta ep-modal__cta--dark">Seguir con la compra →</a>';
        html += '</div>';

        html += '</div></div>';

        document.body.insertAdjacentHTML('beforeend', html);

        // Events
        document.getElementById('ep-close').addEventListener('click', closePopup);
        document.getElementById('ep-overlay').addEventListener('click', function (e) {
            if (e.target === this) closePopup();
        });

        // ─── Variant selectors logic ──────────────────────────────────
        document.querySelectorAll('.ep-product__variants').forEach(function (variantWrap) {
            var pidx = parseInt(variantWrap.dataset.productIdx);
            var product = products[pidx];
            var selects = variantWrap.querySelectorAll('.ep-product__select');
            var addBtn = variantWrap.parentElement.querySelector('.ep-product__add[data-product-idx]');

            selects.forEach(function (sel) {
                sel.addEventListener('change', function () {
                    // Check if all options selected
                    var allSelected = true;
                    var selectedVals = [];
                    selects.forEach(function (s) {
                        if (!s.value) allSelected = false;
                        selectedVals.push(s.value);
                    });
                    if (!allSelected) { addBtn.disabled = true; addBtn.textContent = 'Selecciona'; return; }

                    // Find matching variant
                    var matched = null;
                    for (var vi = 0; vi < product.variants.length; vi++) {
                        var v = product.variants[vi];
                        var opts = v.options || [v.option1, v.option2, v.option3];
                        var match = true;
                        for (var k = 0; k < selectedVals.length; k++) {
                            if (opts[k] !== selectedVals[k]) { match = false; break; }
                        }
                        if (match) { matched = v; break; }
                    }

                    if (matched && matched.available) {
                        addBtn.disabled = false;
                        addBtn.dataset.variantId = matched.id;
                        addBtn.innerHTML = 'Agregar <svg viewBox="0 0 24 24" width="12" height="12"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>';
                    } else {
                        addBtn.disabled = true;
                        addBtn.textContent = matched ? 'Agotado' : 'No disponible';
                    }
                });
            });
        });

        // ─── Add to cart buttons ──────────────────────────────────────
        document.querySelectorAll('.ep-product__add[data-variant-id], .ep-product__add[data-product-idx]').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (btn.disabled) return;
                var vid = btn.dataset.variantId;
                if (!vid) return;
                var originalHtml = btn.innerHTML;
                btn.innerHTML = '<span class="ep-spinner"></span>';
                btn.disabled = true;
                fetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] })
                }).then(function () {
                    btn.innerHTML = '✓ Agregado';
                    btn.classList.add('ep-product__add--success');
                    // Update cart count
                    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
                        if (typeof jQuery !== 'undefined') jQuery(document.body).trigger('cart:updated');
                    });
                    setTimeout(function () {
                        btn.innerHTML = originalHtml;
                        btn.classList.remove('ep-product__add--success');
                        btn.disabled = false;
                    }, 2500);
                }).catch(function () {
                    btn.textContent = 'Error';
                    setTimeout(function () { btn.innerHTML = originalHtml; btn.disabled = false; }, 2000);
                });
            });
        });

        // Carousel navigation
        var track = document.getElementById('ep-track');
        document.getElementById('ep-prev').addEventListener('click', function () {
            track.scrollBy({ left: -200, behavior: 'smooth' });
        });
        document.getElementById('ep-next').addEventListener('click', function () {
            track.scrollBy({ left: 200, behavior: 'smooth' });
        });

        // ESC key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closePopup();
        });
    }

    function closePopup() {
        var overlay = document.getElementById('ep-overlay');
        if (overlay) overlay.remove();
    }

    // ─── Triggers ─────────────────────────────────────────────────────

    // Desktop: exit intent (mouse sale por arriba)
    function onMouseLeave(e) {
        if (e.clientY <= 0) {
            showPopup();
            document.removeEventListener('mouseleave', onMouseLeave);
        }
    }

    // Mobile: scroll up rápido o timer
    var lastScrollY = 0;
    var scrollUpCount = 0;
    function onScroll() {
        var currentY = window.scrollY;
        if (currentY < lastScrollY && currentY < 100) {
            scrollUpCount++;
            if (scrollUpCount > 3) {
                showPopup();
                window.removeEventListener('scroll', onScroll);
            }
        } else {
            scrollUpCount = 0;
        }
        lastScrollY = currentY;
    }

    // Init
    loadProducts().then(function (prods) {
        products = prods;
        if (!products.length) return;

        setTimeout(function () {
            if (TRIGGER_EXIT) {
                document.addEventListener('mouseleave', onMouseLeave);
                if (MOBILE_TRIGGER === 'scroll') {
                    window.addEventListener('scroll', onScroll, { passive: true });
                }
            }
            if (TRIGGER_TIMER || MOBILE_TRIGGER === 'timer') {
                setTimeout(function () {
                    if (!hasTriggered) showPopup();
                }, TIMER_SECONDS * 1000);
            }
        }, DELAY_SECONDS * 1000);

        // Exponer showPopup globalmente para que el botón del mini cart lo llame
        window.epShowPopup = function () {
            if (!products || !products.length) { window.location.href = '/checkout'; return; }
            hasTriggered = false;
            var existing = document.getElementById('ep-overlay');
            if (existing) existing.remove();
            showPopup();
        };
    });

})();
